import { api1 } from "../utils/axiosInstance";
import { API_ENDPOINTS } from "./apiEndpoints";

export const getSheduleAppointments = async (payload) => {
  try {
    const response = await api1.get(
      `${API_ENDPOINTS.GET_APPOINTMENT}/${payload.userId}`
    );

    return response.data.data;
  } catch (error) {
    console.error(
      "Error while fetching data:",
      error.response || error.message
    );
    return null;
  }
};

export const getMentorSheduleAppointments = async (mentorId) => {
  try {
    const response = await api1.get(
      `${API_ENDPOINTS.GET_MENTOR_SLOTS}/${mentorId}`
    );

    return response.data;
  } catch (error) {
    console.error(
      "Error while fetching data:",
      error.response || error.message
    );
    return [];
  }
};

export const deleteSheduleAppointments = async (payload) => {
  try {
    const response = await api1.delete(`/api/schedule/`, {
      data: payload, // ✅ correct key for body in Axios DELETE
    });
    return response.data.data;
  } catch (error) {
    console.error(
      "Error while deleting schedule appointment:",
      error.response || error.message
    );
    return null;
  }
};

export const editSheduleAppointments = async (payload) => {
  try {
    const response = await api1.post(`/api/schedule/`, payload);
    return response.data.data;
  } catch (error) {
    console.error(
      "Error while fetching data:",
      error.response || error.message
    );
    return null;
  }
};

export const bookSlot = async (payload) => {
  try {
    const response = await api1.post(API_ENDPOINTS.BOOK_SLOT, payload);
    return response.data;
  } catch (error) {
    console.error(
      "Error while fetching data:",
      error.response || error.message
    );
    return null;
  }
};
